import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import * as configurationAPI from "../../api/configuration";
import { toast } from "react-toastify";

const initialState = {
  loading: false,
  allfunctionalities: {
    data: null,
  },
  superAdminConfigurations: {
    data: null,
    update: {
      loading: false,
    },
  },
  institutions: {
    data: null,
  },
  perPage: 10,
  page: 1,
  offset: 0,
};

const groupedData = (data) => {
  return data.reduce((result, item) => {
    const { idInstitution } = item;
    if (!result[idInstitution]) {
      result[idInstitution] = [];
    }
    result[idInstitution].push(item);
    return result;
  }, {});
};
const getAllFunctionalities = createAsyncThunk(
  "configuration/getAllFunctionalities",
  async (params, { rejectWithValue }) => {
    try {
      const res = await configurationAPI.getAllFunctionalities(params);
      if (res.data.statusCodeValue >= 400) {
        return rejectWithValue(res.data.body.error);
      }

      return res.data.body;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
const geAllInstitutions = createAsyncThunk(
  "configuration/geAllInstitutions",
  async (params, { rejectWithValue }) => {
    try {
      const res = await configurationAPI.geAllInstitutions(params);
      if (res.data.statusCodeValue >= 400) {
        return rejectWithValue(res.data.body.error);
      }

      return res.data.body;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const getAllSuperAdminConfigurations = createAsyncThunk(
  "configuration/getAllSuperAdminConfigurations",
  async (params, { rejectWithValue }) => {
    try {
      const res = await configurationAPI.getAllSuperAdminConfigurations(params);
      if (res.data.statusCodeValue >= 400) {
        return rejectWithValue(res.data.body.error);
      }
      return res.data.body;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const insertFuncionalities = createAsyncThunk(
  "configuration/insertFuncionalities",
  async (params, { rejectWithValue }) => {
    try {
      console.log("params", params);
      const res = await configurationAPI.insertFuncionalities(params);
      if (res.data.statusCodeValue >= 400) {
        toast.error(res.data.body);

        return rejectWithValue(res.data.body);
      }
      return res.data.body;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const updateFunctionalities = createAsyncThunk(
  "configuration/updateFunctionalities",
  async (params, { rejectWithValue }) => {
    try {
      const res = await configurationAPI.updateFunctionalities(params);
      if (res.data.statusCodeValue >= 400) {
        return rejectWithValue(res.data.body.error);
      }
      return res.data.body;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const configurationSlice = createSlice({
  name: "configuration",
  initialState,
  reducers: {
    resetState: () => {
      return initialState;
    },
    setPerPage: (state, action) => {
      state.perPage = action.payload;
    },
    setOffset: (state, action) => {
      state.offset = action.payload;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
  },
  extraReducers: {
    // getAllFunctionalities
    [getAllFunctionalities.pending]: (state) => {
      state.loading = true;
    },
    [getAllFunctionalities.fulfilled]: (state, action) => {
      state.loading = false;
      state.allfunctionalities.data = action.payload;
    },
    [getAllFunctionalities.rejected]: (state, action) => {
      state.loading = false;
    },

    // geAllInstitutions
    [geAllInstitutions.pending]: (state) => {
      state.loading = true;
    },
    [geAllInstitutions.fulfilled]: (state, action) => {
      state.loading = false;
      state.institutions.data = action.payload;
    },
    [geAllInstitutions.rejected]: (state, action) => {
      state.loading = false;
    },

    // getAllSuperAdminConfigurations
    [getAllSuperAdminConfigurations.pending]: (state) => {
      state.loading = true;
    },
    [getAllSuperAdminConfigurations.fulfilled]: (state, action) => {
      state.loading = false;
      state.superAdminConfigurations.data = action.payload;
      // state.superAdminConfigurations.data.superAdminConfigurations =
        // groupedData(action.payload.superAdminConfigurations);
    },
    [getAllSuperAdminConfigurations.rejected]: (state) => {
      state.loading = false;
    },

    // insertFuncionalities
    [insertFuncionalities.pending]: (state) => {
      state.loading = true;
    },
    [insertFuncionalities.fulfilled]: (state, action) => {
      state.loading = false;
      toast.success(action.payload);
    },
    [insertFuncionalities.rejected]: (state) => {
      state.loading = false;
    },

    // updateFunctionalities
    [updateFunctionalities.pending]: (state) => {
      state.superAdminConfigurations.update.loading = true;
    },
    [updateFunctionalities.fulfilled]: (state, action) => {
      state.superAdminConfigurations.update.loading = false;
      toast.success(action.payload);
    },
    [updateFunctionalities.rejected]: (state) => {
      state.superAdminConfigurations.update.loading = false;
    },
  },
});

const { resetState, setPerPage,
  setOffset,
  setPage, } = configurationSlice.actions;

export default configurationSlice.reducer;

export {
  resetState,
  updateFunctionalities,
  insertFuncionalities,
  getAllSuperAdminConfigurations,
  getAllFunctionalities,
  geAllInstitutions,
  
  setPerPage,
  setOffset,
  setPage,
};
